import { Injectable, Injector, PLATFORM_ID, REQUEST } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ConfigurationService } from '../services/configuration.service';
import { getDeepestPrimaryRoute } from '../utils/router-utils'
import { CanonicalLinkService } from '../services/canonical-link.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { environment } from '../../environments/environment'

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  private restaurantName = '';
  private isInitialized = false;

  constructor(
    private readonly title: Title,
    private readonly canonical: CanonicalLinkService,
    private injector: Injector
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const route = getDeepestPrimaryRoute(routerState.root);
    const disableTitleStrategy = route.data?.['disableTitleStrategy']

    // Title
    if (!disableTitleStrategy) {
      const title = this.buildTitle(routerState);

      if (!this.isInitialized) {
        const siteService = this.injector.get(ConfigurationService);
        siteService.getPublicConfiguration().subscribe(res => {
          this.restaurantName = res.body?.data?.name || '';
          this.isInitialized = true;
          this.applyTitle(title);
        });
      } else {
        this.applyTitle(title);
      }
    }

    // Canonical URL

    const disableCanonicalUrl = route.data?.['disableCanonicalUrl'];
    if (!disableCanonicalUrl) {
      const request = this.injector.get(REQUEST)
      const platformId = this.injector.get(PLATFORM_ID)

      if (isPlatformBrowser(platformId)) {
        this.canonical.setUrl(window.location.href)
      } else if (isPlatformServer(platformId)) {
        this.canonical.setUrl(request?.url || environment.appUrl)
      }
    }
  }

  private applyTitle(pageTitle: string | undefined) {
    if (pageTitle !== undefined) {
      this.title.setTitle(`${pageTitle} - ${this.restaurantName}`);
    } else if (this.restaurantName) {
      this.title.setTitle(this.restaurantName);
    }
  }
}
